// extracted by mini-css-extract-plugin
export default {"faq":"FAQ_faq__PKGnO","faqList":"FAQ_faqList__vO+VA","faqItem":"FAQ_faqItem__E2ioM","question":"FAQ_question__KI-CJ","answer":"FAQ_answer__sDjuJ","fadeIn":"FAQ_fadeIn__NmpqX"};